import {createAsyncThunk} from "@reduxjs/toolkit";
import {RootState} from "../../../store";
import {handlerError} from "../../../store/handleError";
import {setModalMessage} from "../../messages/model/slice";
import {fuelPriceAPI} from "../api";
import {IFuelPrice} from "../../../models/IFuelPrice";

export const fetchFuelPrices = createAsyncThunk<
    IFuelPrice[],
    void,
    { state: RootState }
>("fuel_price/get_all", async (_, {rejectWithValue, dispatch}) => {
    try {
        return await fuelPriceAPI.getPrices();
    } catch (e) {
        const msg = handlerError(e);
        dispatch(setModalMessage(msg));
        return rejectWithValue(msg);
    }
});

interface ISetFuelPriceArgs {
    fuel_type: string;
    price_per_liter: number;
    effective_from?: string;
}

export const fetchSetFuelPrice = createAsyncThunk<
    IFuelPrice,
    ISetFuelPriceArgs,
    { state: RootState }
>(
    "fuel_price/set",
    async ({fuel_type, price_per_liter, effective_from}, {rejectWithValue, dispatch}) => {
        try {
            return await fuelPriceAPI.setPrice(fuel_type, price_per_liter, effective_from);
        } catch (e) {
            const msg = handlerError(e);
            dispatch(setModalMessage(msg));
            return rejectWithValue(msg);
        }
    },
);
